import { paymentMethodsAdd } from './payment-methods-add/payment-methods-add.module';
import { paymentMethodsComponent } from './payment-methods.component';
import { PaymentMethodsService } from './payment-methods.service';

import './payment-methods.scss';

export const paymentMethods = angular
    .module('components.PaymentMethods', [
        paymentMethodsAdd
    ])
    .service('PaymentMethodsService', PaymentMethodsService)
    .component('paymentMethods', paymentMethodsComponent)
    .name;


// WEBPACK FOOTER //
// ./src/app/components/payment-methods/payment-methods.module.js